let language = {
    "COMBINE_ORDER_SETTINGS_DATE_ALERT_SUCCESS_SAVE":"保存成功!"
};

export { language }